import { Component, Input, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Http, Response } from "@angular/http";

import {
    BASE_CONSTANTS,
    BASE_URLS,
    ITCIAppCustomizationParam,
    ITCIUserInfo,
    TCI_APP_CUSTOMIZATION_TYPE
} from "@tci/common";
import { NgUserService } from "../../ng-services/ng-user.service";
import { NgWindowRefService } from "../../ng-services/ng-window-ref.service";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "tci-help",
    templateUrl: "./ng-help.component.html",
    styleUrls: ["./ng-help.component.less"]
})
export class NgHelpComponent implements OnInit {

    private static readonly docsUrl = `${(<any>window).location.origin}/docs/getstarted/reference/csh`;
    private static readonly HELP_PAGES = {
        "applications": [
            {
                id: "ApplicationsHlp",
                title: "TROPOS_HELP_PANEL.APPS_PAGE_HELP",
                url: `${NgHelpComponent.docsUrl}/applications_page_help.html`,
                iconClass: "tropos-apps-icon"
            },
            {
                id: "ApprecreateHlp",
                title: "TROPOS_HELP_PANEL.APPS_CREATE_PAGE_HELP",
                url: `${NgHelpComponent.docsUrl}/appcreate_page_help.html`,
                iconClass: "tropos-app-create-icon"
            }
        ],
        "applicationsdetail": [
            {
                id: "AppDetailHlp",
                title: "TROPOS_HELP_PANEL.APPS_DETAILS_PAGE_HELP",
                url: `${NgHelpComponent.docsUrl}/application_details_page_help.html`,
                iconClass: "tropos-app-details-icon"
            }
        ],
        "apispecs": [
            {
                id: "ApimodelerHlp",
                title: "TROPOS_HELP_PANEL.API_MODELER_PAGE_HELP",
                url: `${NgHelpComponent.docsUrl}/apimodeler_page_help.html`,
                iconClass: "tropos-modeler-icon"
            },
            {
                id: "ApimodelerCreateHlp",
                title: "TROPOS_HELP_PANEL.API_MODELER_CREATE_PAGE_HELP",
                url: `${NgHelpComponent.docsUrl}/apimodeler_createapi_page_help.html`,
                iconClass: "tropos-modeler-create-icon"
            }
        ],
        "download": [
            {
                id: "DownloadHlp",
                title: "TROPOS_HELP_PANEL.DOWNLOADS_PAGE_HELP",
                url: `${NgHelpComponent.docsUrl}/download_page_help.html`,
                iconClass: "tropos-downloads-icon"
            }
        ],
        "connections": [
            {
                id: "ConnectionsHelp",
                title: "Connections Page Help",
                url: `${NgHelpComponent.docsUrl}/connections_page_help.html`,
                iconClass: "tropos-connections-icon"
            }
        ],
        "extensions": [
            {
                id: "ExtensionsHelp",
                title: "Extensions Page Help",
                url: `${NgHelpComponent.docsUrl}/extensions_page_help.html`,
                iconClass: "tropos-extensions-icon"
            }
        ],
        vpn: [
            {
                id: "vpnHelp",
                title: "VPN Page Help",
                url: `${NgHelpComponent.docsUrl}/vpn_page_help.html`,
                iconClass: "tropos-vpn-icon"
            }
        ]
    };
    @Input() helpPanelShown: boolean;
    @Input() navBar: any;
    @Input() customConfig: { [key: string]: ITCIAppCustomizationParam };

    private _window: any;
    private helpReleaseUpdates;
    private newsContentStyle = {};
    private userInfo: ITCIUserInfo;
    private selectedHelpPages = [];
    private flogoDocsVersion = "2.0.0"; // give it a default value 2.0.0

    constructor(
        private http: Http,
        private location: Location,
        private userService: NgUserService,
        private windowRef: NgWindowRefService
    ) {
        this._window = this.windowRef.nativeWindow;
        this
            .userService
            .getUserInfo()
            .subscribe((userInfo: ITCIUserInfo) => {
                this.userInfo = userInfo;
            });
    }

    ngOnInit() {
        const url: string = this.location.path();

        if (url.indexOf("applicationsdetail") === 1) {
            this.selectedHelpPages = NgHelpComponent.HELP_PAGES.applicationsdetail;
        } else if (url.indexOf("applications") === 1) {
            this.selectedHelpPages = NgHelpComponent.HELP_PAGES.applications;
        } else if (url.indexOf("apispecs") === 1) {
            this.selectedHelpPages = NgHelpComponent.HELP_PAGES.apispecs;
        } else if (url.indexOf("download") === 1) {
            this.selectedHelpPages = NgHelpComponent.HELP_PAGES.download;
        } else if (url.indexOf("wistudio/connections") === 1 || url.indexOf("wistudio/connectiondetails") === 1) {
            this.selectedHelpPages = NgHelpComponent.HELP_PAGES.connections;
        } else if (url.indexOf("wistudio/extensions") === 1) {
            this.selectedHelpPages = NgHelpComponent.HELP_PAGES.extensions;
        } else if (url.indexOf("vpn") === 1) {
            this.selectedHelpPages = NgHelpComponent.HELP_PAGES.vpn;
        }

        this.newsContentStyle = {
            "height": `calc(100vh - ${590 + ((this.selectedHelpPages.length - 1) * 40)}px)`
        };

        this.fetchFlogoProductVersion();
    }

    get isFlogoE(): boolean {
        const customParam = this.customConfig[TCI_APP_CUSTOMIZATION_TYPE.HELP_PANEL];

        return customParam ?
            customParam.enabled && customParam.visible && customParam.tenantCustomization :
            false;
    }

    openWelcomeDialog() {
        this.dropdownClick();

        if ("eula" in this.userInfo) {
            // TODO: open pendo pop-up
        }
    }

    supportRedirect() {
        // in-app support form to replace formvine page
        this
            .navBar
            .publishEvent("LAUNCH_SUPPORT_FORM", {
                supportDomain: "TCI"
            });

        // Close Sidebar
        this.dropdownClick();
    }

    private dropdownClick() {
        const elements = document.querySelectorAll(".dropdown-background");
        for (let i = 0; i < elements.length; ++i) {
            (<HTMLElement>elements[i]).click();
        }
    }

    private fetchFlogoProductVersion(): void {
        this
            .http
            .get(`${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.PRODUCT_VERSION}`)
            .subscribe(
                (response: Response) => {
                    try {
                        const result = response.json();

                        if (result && result.productVersion) {
                            this.flogoDocsVersion = result.productVersion;
                        }
                    } catch (e) {
                        console.log("Error getting Flogo product version with the error, ", e);
                    }
                }
            );
    }
}
